<script setup>
import {useStore} from "vuex";
import {computed} from "vue";
import TableCell from "@/components/global-themed/table/TableCell.vue";
import DiffTag from "@/components/global-themed/DiffTag.vue";

const props = defineProps({
  column: {
    type: Number,
    required: true,
  },
  name: {
    type: String,
    required: true,
  }
});

const store = useStore();

const competitor = computed(() => store.getters['competitionV2/compareCompetitors'][props.column - 1] ?? undefined);
const data = computed(() => store.getters['competitionV2/compareCompetitorsData'][props.column - 1] ?? undefined);
const value = computed(() => data.value ? data.value[props.name] : undefined);

const websiteValue = computed(() => store.getters['competitionV2/websiteCompareData']
  ? store.getters['competitionV2/websiteCompareData'][props.name]
  : undefined);

</script>

<template>
  <TableCell
    class="text-center"
    col-span="2"
  >
    <span v-if="competitor !== undefined">
      {{ value?.toLocaleString() ?? '-' }}
    </span>
    <span
      v-else
      class="tw-text-grey"
    >
      -
    </span>

    <DiffTag
      v-if="websiteValue !== undefined && value !== undefined"
      :compare="websiteValue"
      :value="value"
      inverted
    />
  </TableCell>
</template>